<template>
  <header class="cabecera bg-primary">
    <div class="container">
      <div class="row">
        <div class="col barra">
          <div class="float-left der-icon">
            <img
              src="@/assets/images/Logo-Kia.png"
              alt="KIA LOGO"
              style="padding-top: 1rem"
            />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
header {
  font-size: 10px;
  margin-top: -3px;
}
.kia {
  cursor: pointer;
}
.barra {
  margin-top: 10px;
  margin-bottom: 10px;
}
.der-icon {
  height: 100%;
}
.centro {
  margin-top: auto;
  margin-bottom: auto;
}
.logo-main {
  max-height: 80px;
}
.linea {
  -webkit-box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.75);
}
.logo-white {
  max-height: 40px;
}
.kt-input-icon__icon {
  cursor: pointer;
}
.la {
  color: black;
}
</style>
